module.exports = __webpack_public_path__ + "Roboto-Thin.46888f279ddb7baaf897.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Thin.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Thin.woff2
// module chunks = styles